export const GET_ALL_CURRENCIES_REQUEST="GET_ALL_LANGUAGE_REQUEST"
export const GET_ALL_CURRENCIES_SUCCESS="GET_ALL_LANGUAGE_SUCCESS"
export const GET_ALL_CURRENCIES_FAILURE="GET_ALL_LANGUAGE_FAILURE"